import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { secondAxios } from "../../../../../api/axios";
import TaskList from "./TaskList";
import { useParams } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const PlantTasksWrapper = ({ type, mrq }) => {
  const queryClient = new QueryClient();
  const [plant, setPlant] = useState(null);
  const { plantId } = useParams();

  useEffect(() => {
    const getPlant = async () => {
      try {
        const response = await secondAxios.get(`/plant/${plantId}`);
        console.log("selected plant", response.data);
        setPlant(response.data);
      } catch (err) {
        console.error("Error fetching plant:", err);
      }
    };
    if (plantId) {
      getPlant();
    }
  }, [plantId]);

  return (
    <QueryClientProvider client={queryClient}>
      <Box sx={{ width: "100%", maxWidth: "100%" }}>
        {plant && <TaskList selectedPlant={plant} type={type} mrq={mrq} />}
      </Box>
    </QueryClientProvider>
  );
};

export default PlantTasksWrapper;

